import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import { Search } from 'lucide-react';
import { Button, DefaultTable } from 'twyne-new.ui';

import { Card } from '@/components/reports/card';
import ObjectModal from '@Components/modals/ObjectModal';
import { formatDateTime } from '@Utils/index';

import store from '../../../stores/inquiry'

import { getUrlLink, formatBool, CardTitle } from './utils'

export default function IntegrationResult({ data }) {
  if (!data.length) return null

  return (
    <Card
      title={<CardTitle title="Integrations" subtitle={`total: ${data.length}`} />}>
      <DefaultTable keyField="id"
        data={data || []}
        columns={[
          {
            dataField: 'delivery_date',
            text: 'Delivery Date',
            formatter: formatDateTime,
          },
          {
            dataField: 'integration_id',
            text: 'Integration Id',
            formatter: cell => cell ? <Link to={`${getUrlLink('integration')}/${cell}`}>
              {store.integration.objectsMapping[cell]?.getLabel() || cell}
            </Link> : 'Default',
          },
          {
            dataField: 'u_session_id',
            text: 'uSession Id',
          },
          {
            dataField: 'user_id',
            text: 'User Id',
          },
          {
            dataField: 'integration_type',
            text: 'Type',
          },
          {
            dataField: 'vendor',
            text: 'Vendor',
          },
          {
            dataField: 'http.request.method',
            text: 'Method',
          },
          {
            dataField: 'success',
            text: 'Success',
            formatter: formatBool,
          },
          {
            dataField: 'publisher_id',
            text: 'Publisher Id',
            formatter: cell => <Link to={`${getUrlLink('publisher')}/${cell}`}>
              {store.publisher.objectsMapping[cell]?.getLabel() || cell}
            </Link>,
          },
          {
            dataField: 'allocation_id',
            text: 'Allocation Id',
            formatter: cell => <Link to={`${getUrlLink('allocation')}/${cell}`}>
              {store.allocation.objectsMapping[cell]?.getLabel() || cell}
            </Link>,
          },
          {
            dataField: '',
            text: '',
            formatter: (_, row) => {
              const ButtonOpen = ({ id, handleToggle }) => <Button variant='ghost' color='accent' id={id} onClick={handleToggle}>
                <Search size={16} />
              </Button>
              const integrationData = Object.entries(row || {}).filter(([key]) => !['@timestamp', '@version', 'idx_action', 'idx_date'].includes(key))
              return <ObjectModal id="integration-modal" button={ButtonOpen} title="Integration Data" data={integrationData} />
            },
          },
        ]}
        bordered={false}
        noDataIndication={() => 'No content to show.'}
      />
    </Card>
  )
}

const propTypes = { data: PropTypes.object }
IntegrationResult.propTypes = propTypes
IntegrationResult.defaultProps = { data: [] }
